<template>
  <div>
    <div>
      <b-card no-body class="overflow-hidden">
        <b-row no-gutters>
          <b-col>
            <b-card-img v-bind:src="place.imgUrl" class="rounded-0"></b-card-img>
          </b-col>
        </b-row>
        <b-row no-gutters>
          <b-col>
            <b-card-body v-bind:title="place.name">
              <b-card-text style="white-space:pre-wrap;">{{place.description}}</b-card-text>
              <b-card-text>営業時間：{{place.hour}}</b-card-text>
              
              <div id="map"></div>
              <router-link :to="{ name: 'EditPlace' , params: { placeId: placeId}}" v-if="authed">
                <font-awesome-icon icon="cog" /><!--これを追加 -->
              </router-link>

            </b-card-body>
          </b-col>
        </b-row>
        
      </b-card>
      <b-row class="mt-4">
        <b-col>
          <b-button block  variant="outline-secondary" to="/">TOPに戻る</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { db, auth } from '@/firebase/firebase'
export default {
  name: 'Place',
  data () {
    return {
      place: {},
      placeId : null
    }
  },
  computed: {
    authed : function() {
      auth.currentUser
    }
  },
  methods: {
    renderMap () {
      //renderMap()の中身を書き換える
      if(this.place.latLng) { //37.12345, 140.12345
        let arr = this.place.latLng.split(',') // arr => [37.12345, 140.12345]
        let lat = parseFloat(arr[0]) //37.12345,
        let lng = parseFloat(arr[1]) //140.12345
        this.mapOptions = {
          center: new google.maps.LatLng(lat, lng),
          zoom: 16,
          mapTypeId: 'roadmap'
        }
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions)
        var marker = new google.maps.Marker({position: {lat,lng}, map: this.map})
      }
      // this.mapOptions = {
      //   center: new google.maps.LatLng(37.6284152,140.9897629),
      //   zoom: 17,
      //   mapTypeId: 'roadmap'
      // }
      // this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions)
    }
  },
  // firestore () {
  //   return {
  //     place: db.collection('places').doc(this.$route.params.placeId)
  //   }
  // },
  mounted () {
    //mountedの中身を書き換える
    let _this = this
    this.placeId = this.$route.params.placeId
    db.collection("places").doc(this.$route.params.placeId).get().then(function(snapshot) {
      _this.place = snapshot.data()
      _this.renderMap()
    })
  }
}
</script>

<style scoped>
#map {
  height: 50vh;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Place.vue